<template>
<div>
   <div id="save_options" class="block-button-wrapper">
      <div class="buttons-left">
         <button v-if="isEditing" @click="$emit('deleteClicked')" id="delete_btn" class="red block-btn">
            <div v-if="isDeleting">
               <div class="loader-wrapper">
                  <div class="loader">
                  </div>
               </div>
            </div>
            Delete
         </button>

         <!-- <button v-if="isEditing && isFeed" @click="$emit('archiveClicked')" id="archive_btn" class="yellow block-btn">
            <div v-if="isArchiving">
               <div class="loader-wrapper">
                  <div class="loader">
                  </div>
               </div>
            </div>
            Archive
         </button> -->
         <button @click="$emit('cancelClicked')" id="cancel_btn" class="white block-btn">Cancel</button>
      </div>
      
      <!-- <div class="buttons-center" v-if="!isFeed">
         <button v-if="isTrigger" @click="$emit('revertTriggersClicked')" id="save_revert_btn" class="blue block-btn">Revert to Program Block</button>
         <button v-else @click="$emit('saveTriggersClicked')"  id="save_triggers_btn" class="green block-btn">Save As Triggers</button>
      </div> -->

      <div class="buttons-right">
         <button v-if="isEditing && unsavedChanges" @click="$emit('resetClicked')" id="reset_block_btn" class="white block-btn">Reset</button>
         <button v-if="isFeed" @click="$emit('saveAsDraftClicked')" id="save_as_draft_btn" class="white block-btn">
            <span>Save As Draft</span>
         </button>
         <button v-if="isEditing" @click="$emit('saveAsClicked')" id="save_as_block_btn" class="white block-btn">
            <div v-if="isSavingAs">
               <div class="loader-wrapper">
                  <div class="loader">
                  </div>
               </div>
            </div>
            <span v-show="!isSavingAs">Save As</span>
         </button>
         <button @click="$emit('saveClicked')" id="save_block_btn" class="white block-btn">
            <div v-if="isSaving">
               <div class="loader-wrapper">
                  <div class="loader">
                  </div>
               </div>
            </div>
            <span v-show="!isSaving">Save</span>
         </button>
      </div>

   </div>
</div>
</template>

<script>
import BaseActionBar from '@/global/BaseActionBar';

export default {
   extends: BaseActionBar,
   props: [
      'isFeed',
      'isTrigger',
      'isEditing',
      'isSaving',
      'isSavingAs',
      'unsavedChanges',
      'isArchiving',
      'isDeleting',
      'showMP',
      'userRole',
      'start_date',
      'end_date',
      'start_time',
      'end_time'
   ],

   computed: {

      //if block is currently playing, do not allow for deletion
      showDelete() {
         let startDT = new Date(this.start_date);
         let endDT = new Date(this.end_date);
         let today = new Date();
         if (today < startDT || today > endDT) {
            return true;
         } 

         let sTimeDT = new Date();
         let sTimeSplit = this.start_time.split(':');
         sTimeDT.setHours(sTimeSplit[0]);
         sTimeDT.setMinutes(sTimeSplit[1]);
         sTimeDT.setSeconds(sTimeSplit[2]);

         let eTimeDT = new Date();
         let eTimeSplit = this.end_time.split(':');
         eTimeDT.setHours(eTimeSplit[0]);
         eTimeDT.setMinutes(eTimeSplit[1]);
         eTimeDT.setSeconds(eTimeSplit[2]);

         if (today >= sTimeDT && today <= eTimeDT) {
            return false;
         }

         return true;
      }
   }
}
</script>